import { render, staticRenderFns } from "./AnnotationCard.vue?vue&type=template&id=af82f4a4&"
import script from "./AnnotationCard.vue?vue&type=script&lang=js&"
export * from "./AnnotationCard.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationCard.vue?vue&type=style&index=0&id=af82f4a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports